import React, { useEffect, useState } from 'react';
import { useT } from '../i18n';
interface SlideThreeProps {
  selectedOption: number | null;
  onBack: () => void;
  onCTA: () => void;
}
export function SlideThree({
  selectedOption,
  onBack,
  onCTA
}: SlideThreeProps) {
  const {
    t
  } = useT();
  const [showTwo, setShowTwo] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowTwo(true);
    }, 1200);
    return () => clearTimeout(timer);
  }, []);
  return <div className="flex flex-col h-full w-full justify-center" data-id="element-238">
      {/* Back button */}
      <button onClick={onBack} className="self-start mb-4 flex items-center text-solventum-secondary hover:text-white transition-colors duration-200 text-sm font-body group" aria-label="Go back" data-id="element-239">
        <svg className="w-4 h-4 mr-1.5 transition-transform duration-200 group-hover:-translate-x-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-240">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" data-id="element-241" />
        </svg>
        {t('back')}
      </button>

      {/* Big Number Animation */}
      <div className="relative h-44 md:h-52 w-full flex items-center justify-center mb-4" data-id="element-242">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 text-solventum-secondary text-sm md:text-base font-body uppercase tracking-widest animate-fade-in" data-id="element-243">
          {t('proof.from')}
        </div>
        <div className={`absolute top-1/2 left-1/2 font-headline font-extrabold text-8xl md:text-9xl text-white transition-all duration-700 ease-in-out ${showTwo ? 'opacity-0 scale-75 -translate-x-1/2 -translate-y-1/2 blur-sm' : 'opacity-100 scale-100 -translate-x-1/2 -translate-y-1/2 blur-0'}`} data-id="element-244">
          20
        </div>
        <div className={`absolute top-1/2 left-1/2 font-headline font-extrabold text-8xl md:text-9xl text-solventum-primary transition-all duration-700 ease-in-out delay-100 ${showTwo ? 'opacity-100 scale-100 -translate-x-1/2 -translate-y-1/2 blur-0' : 'opacity-0 scale-125 -translate-x-1/2 -translate-y-1/2 blur-sm'}`} data-id="element-245">
          2
        </div>
      </div>

      <div className="animate-fade-in-up opacity-0-init" style={{
      animationDelay: '1800ms'
    }} data-id="element-246">
        <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-6 text-center" data-id="element-247">
          {t('proof.headline')}
        </h2>

        {/* Dr. testimonial card */}
        <div className="bg-white/5 border border-white/10 rounded-2xl p-5 mb-6 backdrop-blur-sm flex items-start gap-4" data-id="element-248">
          <div className="flex-shrink-0" data-id="element-249">
            <img src="https://cdn.magicpatterns.com/uploads/n2L22w3wxJXg65Cp6HYYer/Screenshot_2026-03-27_at_09.58.15.png" alt="Dr. Nils Jørgen Selliseth" className="w-20 h-20 rounded-full object-cover object-top border-2 border-solventum-primary" data-id="element-250" />
          </div>
          <div className="flex-1" data-id="element-251">
            <p className="italic text-white/90 font-body text-base leading-relaxed mb-3" data-id="element-252">
              {t('proof.quote')}
            </p>
            <div className="flex items-center gap-2" data-id="element-253">
              <div className="w-6 h-px bg-solventum-primary" data-id="element-254"></div>
              <p className="text-solventum-primary font-headline font-bold text-sm" data-id="element-255">
                Dr. Nils Jørgen Selliseth
              </p>
            </div>
          </div>
        </div>

        <p className="text-xl text-white font-body mb-2 text-center" data-id="element-256">
          {t('proof.reality')}
        </p>
        <p className="text-sm text-solventum-secondary font-body mb-8 text-center" data-id="element-257">
          {t('proof.substep')}
        </p>
      </div>

      <div className="animate-fade-in-up opacity-0-init" style={{
      animationDelay: '2200ms'
    }} data-id="element-258">
        <button onClick={onCTA} className="w-full bg-solventum-primary hover:bg-[#04c444] text-solventum-bg font-headline font-extrabold py-4 px-6 rounded-xl transition-colors duration-200 text-lg shadow-[0_0_15px_rgba(5,221,77,0.2)]" data-id="element-259">
          {t('proof.cta')}
        </button>
      </div>
    </div>;
}